import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Injectable, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgbModule, NgbDateParserFormatter, NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader, } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StartPageComponent } from './start-page/start-page.component';
import { UserDetailsComponent } from './user-details/user-details.component';
import { MashkantaQuestionerComponent } from './mashkanta-questioner/mashkanta-questioner.component';
import { LoanDetailsComponent } from './loan-details/loan-details.component';
import { QuestionComponent } from './question/question.component';
import { LoanDetailsQ1Component } from './loan-details/loan-details-q1/loan-details-q1.component';
import { PropertyDetailsComponent } from './property-details/property-details.component';
import { BorrowersDetailsComponent } from './borrowers-details/borrowers-details.component';
import { FinancingSourcesComponent } from './financing-sources/financing-sources.component';
import { LiabilitiesComponent } from './liabilities/liabilities.component';
import { AddBorrowerComponent } from './add-borrower/add-borrower.component';
import { LineOtherIncomeComponent } from './line-other-income/line-other-income.component';
import { CanProceedGuard } from './can-proceed.guard';
import { QuestionnaireService } from './services/questionnaire.service';
import { StepIndicatorComponent } from './step-indicator/step-indicator.component';
import { BoxSelectorComponent } from './box-selector/box-selector.component';
import { SummarizePageComponent } from './summarize-page/summarize-page.component';
import { EndPageComponent } from './end-page/end-page.component';
import { QuestionsManagerComponent } from './questions-manager/questions-manager.component';
import { AddLiabilityComponent } from './add-liability/add-liability.component';
import { InnerTooltipComponent } from './inner-tooltip/inner-tooltip.component';
import { AnalyticsService } from './services/analytics.service';
import { EstimatedFinishTimeComponent } from './estimated-finish-time/estimated-finish-time.component';
import { FooterComponent } from './footer/footer.component';
import { HelpDialogComponent } from './help-dialog/help-dialog.component';
import { MatAutocompleteModule, MatInputModule, MatFormFieldModule } from '@angular/material';
import { IncomesArrayComponent } from './incomes-array/incomes-array.component';
import { LeadService } from './services/lead.service';
import { SystemTablesService } from './services/system-tables.service';
import { LiabilitiesArrayComponent } from './liabilities-array/liabilities-array.component';
import { ModalWindowComponent } from './modal-window/modal-window.component';
import { PhoneNumberComponent } from './phone-number/phone-number.component';
import { ChatComponent } from './chat/chat.component';
import { BorrowersArrayComponent } from './borrowers-array/borrowers-array.component';
import { RestartDialogComponent } from './restart-dialog/restart-dialog.component';
import { Click2changeDirective } from './directives/click2change.directive';
import { PercentageMaskDirective } from './directives/percentageMask.directive';
import { HeaderComponent } from './header/header.component';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from "ng2-currency-mask/src/currency-mask.config";
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { toInteger } from "@ng-bootstrap/ng-bootstrap/util/util";
import { AdvisorsComponent } from './advisors/advisors.component';
import { mixtureComponent } from './mixture/mixture.component';
import { MixtureRowComponent } from './mixture-row/mixture-row.component';
import { AddMaslolComponent } from "./add-maslol/add-maslol.component";
import { CycleMixtureComponent } from "./cycle-mixture/cycle-mixture.component";
import { AddTikNumComponent } from "./add-tik-num/add-tik-num.component";
import { CycleMixtureRowComponent } from "./cycle-mixture-row/cycle-mixture-row.component";
import { InternalTikNumArrayComponent } from "./internal-tik-num-array/internal-tik-num-array.component";
import { InternalMaslolComponent } from "./internal-maslol-array/internal-maslol-array.component";
import { CycleDetailsComponent } from "./cycle-details/cycle-details.component";
import { UserMoreDetailsComponent } from "./user-more-details/user-more-details.component";
import { ConfirmCodeComponent } from "./login/otp/confirm-code/confirm-code.component";
import { GetCodeComponent } from "./login/otp/get-code/get-code.component";
import { OtpService } from "./services/otp.service";
import { NoIdDialogComponent } from './no-id-dialog/no-id-dialog.component';
import { ProcessSaveDialogComponent } from './process-save-dialog/process-save-dialog.component';
import { FinancingSourcesPopupComponent } from './financing-sources-popup/financing-sources-popup.component';
import { LoginPageComponent } from './login/login-page/login-page.component';
import { LoginComponent } from './login/login.component';
import { OtpComponent } from "./login/otp/otp.component";
import { APIInterceptor } from "./interceptors/api.interceptor";
import { UtilService } from "./services/util.service";
import { Draft } from './services/draft.service';
import { JWTService } from "./services/jwt.service";
import { PlaygroundComponent } from './playground/playground.component';
import { DplistComponent } from './dplist/dplist.component';
import { SessionService } from "./services/session.service";
import { SessionDialogComponent } from "./session-dialog/session-dialog.component";
import { NumbersOnlyDirective } from "../app/directives/numbersOnly.directive";
import { DplistComponentNew } from "./dpListNew/dplistNew.component";
import { DraftHttpService } from "./services/draft-http.service";
import { MessageComponent } from "./message-component/message-component.component";
import { LoaderPageComponent } from './loader-page/loader-page.component';
import { MatAutocompleteComponent } from './mat-autocomplete/mat-autocomplete.component';
import { TermsOfUseFinalComponent } from './terms-of-use-final/terms-of-use-final.component';
import { AnimatedInputComponent } from './animated-input/animated-input.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { SafeHtmlPipe } from "./Pipes/safeHtml.pipe";

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "right",
  allowNegative: false,
  decimal: ".",
  precision: 0,
  prefix: ' ',
  suffix: ' ₪ ',
  thousands: ","
};

// export class CustomNgbDatepickerConfig extends NgbDatepickerConfig {
//   minDate: {year: 1900, month: 1, day: 1}
// };


export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct {
    if (value) {
      const dateParts = value.trim().split('/');
      return { day: toInteger(dateParts[0]), month: toInteger(dateParts[1]), year: toInteger(dateParts[2]) };
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    return date ? date.day + '/' + date.month + '/' + date.year : '';
  }

}

const I18N_VALUES = {

  'he': {
    weekdays: ['ב', 'ג', 'ד', 'ה', 'ו', 'ש', 'א'],
    months: ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'],
  }
};



@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

  constructor() {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES['he'].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES['he'].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }
}


// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@Injectable()

@NgModule({
  declarations: [
    AppComponent,
    StartPageComponent,
    UserDetailsComponent,
    MashkantaQuestionerComponent,
    LoanDetailsComponent,
    QuestionComponent,
    LoanDetailsQ1Component,
    PropertyDetailsComponent,
    BorrowersDetailsComponent,
    FinancingSourcesComponent,
    LiabilitiesComponent,
    AddBorrowerComponent,
    LineOtherIncomeComponent,
    StepIndicatorComponent,
    BoxSelectorComponent,
    SummarizePageComponent,
    EndPageComponent,
    QuestionsManagerComponent,
    AddLiabilityComponent,
    InnerTooltipComponent,
    EstimatedFinishTimeComponent,
    FooterComponent,
    HelpDialogComponent,
    IncomesArrayComponent,
    LiabilitiesArrayComponent,
    ModalWindowComponent,
    PhoneNumberComponent,
    ChatComponent,
    BorrowersArrayComponent,
    HelpDialogComponent,
    RestartDialogComponent,
    AdvisorsComponent,
    mixtureComponent,
    MixtureRowComponent,
    Click2changeDirective,
    PercentageMaskDirective,
    HeaderComponent,
    TermsOfUseComponent,
    AddMaslolComponent,
    CycleMixtureComponent,
    AddTikNumComponent,
    CycleMixtureRowComponent,
    InternalTikNumArrayComponent,
    InternalMaslolComponent,
    CycleDetailsComponent,
    UserMoreDetailsComponent,
    NoIdDialogComponent,
    ProcessSaveDialogComponent,
    FinancingSourcesPopupComponent,
    LoginPageComponent,
    LoginComponent,
    PlaygroundComponent,
    DplistComponent,
    ConfirmCodeComponent,
    GetCodeComponent,
    OtpComponent,
    SessionDialogComponent,
    LoaderPageComponent,
    MatAutocompleteComponent,
    TermsOfUseFinalComponent,
    AnimatedInputComponent,
    DatePickerComponent,
    NumbersOnlyDirective,
    DplistComponentNew,
    MessageComponent,
    SafeHtmlPipe
    // CustomDatePickerComponent

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    CurrencyMaskModule,
    NgbModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: APIInterceptor,
      multi: true,
    },
    CanProceedGuard,
    QuestionnaireService,
    Draft,
    DraftHttpService,
    AnalyticsService,
    LeadService,
    SystemTablesService,
    OtpService,
    UtilService,
    JWTService,
    SessionService,
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }
    //{provide: NgbDateParserFormatter, useClass: CustomNgbDatepickerConfig}

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [HelpDialogComponent, TermsOfUseFinalComponent, RestartDialogComponent, TermsOfUseComponent, ModalWindowComponent, ProcessSaveDialogComponent, FinancingSourcesPopupComponent, NoIdDialogComponent, SessionDialogComponent],
  bootstrap: [AppComponent]

})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts